import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

export interface SubscriptionUpdateRequest {
  type: string
  start: string
  end: string
  transaction_id: string
}

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  updateSubscription(data: SubscriptionUpdateRequest): Observable<any> {
    this.logger.info('SubscriptionService | updateSubscription | data:', data)
    return this.http.post<any>(`${Backend.HOST_CONTAINER + Backend.SUBSCRIPTION}`, data)
  }
}
